import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import numeral from 'numeral';
 
class ComponentToPrint extends React.Component {

  render() {
    const { data } = this.props;
    return (
      <div style={{ padding: 10 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          border: "1px solid #ccc",
          padding: 10
        }}
      >
        <div>
          <div style={{ textAlign: "left" }}>
            <h3>Peso y pies cúbicos de guias master</h3>
          </div>
        </div>
        <div>
          <div style={{ textAlign: "right" }}>
            <small style={{ padding: 0 }}>Generedo el</small>
            <div>{moment().format('DD/MM/YYYY')}</div>
          </div>
        </div>
      </div>
      {data.map(e => {
       return <div style={{ marginTop: 15,  border: "1px solid #ccc" }}>
          <div style={{ width: '100%', display: 'flex', backgroundColor: '#dfddddcc', paddingLeft: 10, paddingRight: 10 }}>
            <div style={{ width: '40%'}}>
              <b>Guia master</b>
            </div>
            <div style={{ width: '20%', textAlign: 'right'}}>
              <b>Tipo</b>
            </div>
            <div style={{ width: '20%', textAlign: 'right'}}>
              <b>Total peso (Kg)</b>
            </div>
            <div style={{ width: '20%', textAlign: 'right'}}>
              <b>Total Ft3</b>
            </div>
          </div>

          <div style={{ width: '100%', display: 'flex', paddingLeft: 10, paddingRight: 10 }}>
            <div style={{ width: '40%'}}>
              {e.description}
            </div>
            <div style={{ width: '20%', textAlign: 'right'}}>
              {e.rel_tipos.description}
            </div>
            <div style={{ width: '20%', textAlign: 'right'}}>
              {numeral(e.peso_total).format('0.00')}
            </div>
            <div style={{ width: '20%', textAlign: 'right'}}>
              {numeral(e.pie_total).format('0.00')}
            </div>
          </div>
        </div>
      })}
    </div>
    );
  }
}
 
const PesoPiesPrinter = ({ data, master, config }) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  return (
    <div>
      <div style={{ display: 'none'}}>
       <ComponentToPrint data={data} prefijo={config.prefijo_correlativo_guia} ref={componentRef} />
      </div>
      <button onClick={handlePrint} type="button" className="btnx btnx-warn mr-1">Imprimir reporte</button>
    </div>
  );
};

export default PesoPiesPrinter;